export default __webpack_public_path__ + "static/media/TaskListApp.1c60a427.pdf";